import ApiService from './ApiService';
import Session from './Session';
import StatesService from './StatesService';
const API_URLS = window.AppConfig.API_URLS;

export default class UserService {
	/**
	 * This function is used for get current user profile.
	 * @return {User}
	 */
	static async getCurrentUser() {
		return ApiService.GetData(API_URLS.PROFILE, 'user');
	}

	/**
	 * This function is used for update current user profile.
	 * @return {User}
	 */
	static async updateCurrentUser() {
		const profile = await ApiService.GetData(API_URLS.PROFILE, 'user');
		const currentUserInfo = Session.get('CURRENT_USER_INFO');
		if (profile) {
			if (profile.state) {
				const stateData = await StatesService.getStateById(profile.state);
				if (stateData && stateData.name) {
					profile.state_name = stateData.name;
				}
			}
			currentUserInfo.profile = profile;
		}
		Session.store('CURRENT_USER_INFO', currentUserInfo);
		return currentUserInfo;
	}

	static async changePassword(oldPassword, newPassword) {
		const request = {
			oldPassword,
			newPassword
		};
		return ApiService.PostData(`${API_URLS.USER_CHANGE_PASSWORD}`, request, 'user');
	}

	static async updateUserInfo(user) {
		return ApiService.PatchData(API_URLS.USER, user, 'user');
	}

	static async updateContactInfo(user) {
		return ApiService.PostData(API_URLS.UPDATE_USER_INFO, user, 'user');
	}

	static async verifyUserContactDetail(user) {
		return ApiService.PatchData(API_URLS.VERIFY_USER_INFO, user, 'user');
	}

	static async doesUserExist(user) {
		return ApiService.PostData(API_URLS.IS_USER_EXIST, user, 'user');
	}

	static async create(user) {
		return ApiService.PostData(API_URLS.USER, user, 'user');
	}

	
	static async updateStatus(id, requestBody) {
		return ApiService.PatchData(`${API_URLS.USER}/${id}/${API_URLS.UPDATE_STATUS}`, requestBody, 'user');
	}

	static async activateUser(id, requestBody) {
		return ApiService.PatchData(`${API_URLS.USER}/${id}/${API_URLS.UPDATE_STATUS}`, requestBody, 'user');
	}

	static async getKycStatus(obj) {
		return ApiService.GetData(`${API_URLS.USER}/${obj.id}/${obj.action}`, 'user');
	}

	static async getUserById(id) {
		return ApiService.GetData(`${API_URLS.USER}/${id}`, 'user');
	}

	static async getUserByPhone(phone) {
		return ApiService.GetData(`${API_URLS.USERS_PHONE}?phone=${phone}`, 'user');
	}

	static async getAllUsers(queryUrl = '') {
		return ApiService.GetData(`${API_URLS.USER}${queryUrl}`, 'user');
	}

	static async listOfActiveUsers() {
		return ApiService.GetData(`${API_URLS.LIST_ACTIVE_USERS}`, 'user');
	}

	static async signedUrlUploadId(id, requestBody) {
		return ApiService.PostData(`${API_URLS.USER}/${id}/${API_URLS.UPLOAD_ID}`, requestBody, 'user');
	}
}
